import request from "../utils/request";

export function fetcTableData(params) {
  // is_paginated=0 page page_size
  // let data = [
  //   {
  //     id: "1",
  //     type: "Тип",
  //     C13H16F3N3O4: 1.5,
  //     "(NH4)+": 1.1,
  //     C3H4Cl2O2: 1.9,
  //     "SO₄²-": 3.2,
  //     "Cl-": 6.3,
  //     С12Н15СlNO4PS2: 9.8,
  //     "NO3-": 12.1,
  //     "4d105s2": 6.7,
  //     location: "location",
  //     date: new Date().toLocaleDateString()
  //   }
  // ];
  // return Promise.resolve({ data: { data, count: 1 } });
  return request({
    url: "/api/orgs/agriculture-first/",
    method: "get",
    params
  });
}
export function fetchChartData(params) {
  // is_paginated=0 page page_size

  return Promise.resolve([]);
  // return request({
  //   url: "/api/orgs/geology/water-deposits/",
  //   method: "get",
  //   params
  // });
}
export function fetchLocationData({id}) {
  return request({
    url: `/api/orgs/agriculture-first/${id}`,
    method: "get",
  });
}
